import { useMutation } from '@tanstack/react-query';
import { apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';

export interface PushSubscriptionPayload {
  endpoint: string;
  keys: {
    p256dh: string;
    auth: string;
  };
}

interface VapidPublicKeyResponse {
  public_key: string;
}

export async function fetchVapidPublicKey(): Promise<string> {
  const response: VapidPublicKeyResponse = await baseFetcher(
    apiRoutes.pushVapidPublicKey()
  );

  return response.public_key;
}

export function registerPushSubscription(
  subscription: PushSubscriptionPayload
): Promise<unknown> {
  return baseFetcher(apiRoutes.pushSubscriptions(), {
    method: 'POST',
    data: subscription,
  });
}

export function useRegisterPushSubscription() {
  return useMutation<unknown, unknown, PushSubscriptionPayload>({
    mutationFn: registerPushSubscription,
  });
}

export function useUnregisterPushSubscription() {
  return useMutation<unknown, unknown, string>({
    mutationFn: (endpoint) =>
      baseFetcher(apiRoutes.pushSubscriptionsUnregister(), {
        method: 'POST',
        data: { endpoint },
      }),
  });
}
